import { CAMPAIGNS_GRID_NAME } from '../../constants';

import { actionLoadCampaignsRequest } from '../../actions/campaignsGrid';

import {
  ACTION_CREATE_CAMPAIGN__REQUEST,
  ACTION_CREATE_CAMPAIGN__SUCCESS,
  ACTION_CREATE_CAMPAIGN__FAIL,
  ACTION_EDIT_CAMPAIGN__REQUEST,
  ACTION_EDIT_CAMPAIGN__SUCCESS,
  ACTION_EDIT_CAMPAIGN__FAIL,
  ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST,
  ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS,
  ACTION_SWITCH_CAMPAIGN_STATUS__FAIL,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  CAMPAIGNS_GRID_NAME,
  actionLoadCampaignsRequest,
  [
    ACTION_CREATE_CAMPAIGN__REQUEST,
    ACTION_EDIT_CAMPAIGN__REQUEST,
    ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST,
  ],
  [
    ACTION_CREATE_CAMPAIGN__FAIL,
    ACTION_EDIT_CAMPAIGN__FAIL,
    ACTION_SWITCH_CAMPAIGN_STATUS__FAIL,
  ],
  [
    ACTION_CREATE_CAMPAIGN__SUCCESS,
    ACTION_EDIT_CAMPAIGN__SUCCESS,
    ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS,
  ]
);
